<div>
    @if (content().title) {
    <h1>
        {{ content().title | translate }}@if (courseTitle()) {
        : {{ courseTitle() | translate }}
        }
    </h1>
    }
    @if (content().titleLabel) {
    <span id="titleLabel">{{ content().titleLabel | translate }} {{ content().diningLocation?.label ?? '' }}</span>
    }
    @if (content().subtitle) {
    <h2 class="subtitle">{{ content().subtitle | translate }}</h2>
    }
    @if (hasLabelRow()) {
    <div class="label-container">
        @if (content().label !== undefined) {
        <div class="label">
            <span id="labelContent">{{ content().label | translate }}</span>
            @if (isNews()) {
            <span class="labelContentPrefix">@if (content().label) {
                <span>&nbsp;-&nbsp;</span>
                }{{ "NEWS.News" | translate }}</span>
            }
        </div>
        }
        @if (hasIcons()) {
        <div class="image-container">
            @if (content().hasZoom) {
            <img class="img"
                src="assets/images/zoom-icon.png"
                alt="zoom-icon" />
            }
            @if (content().hasYoutube) {
            <img class="img"
                src="assets/images/youtube-icon.png"
                alt="youtube-icon" />
            }
        </div>
        }
    </div>
    }
</div>
@if (content().diningContent) {
<div class="body-content"
    [dsScrollContent]="controller()">
    <div class="fade-overlay-top"></div>
    @for (diningContent of content().diningContent; track diningContent.course) {
    <div class="ds-dining-wrapper">
        @if (content().diningContent.length > 1) {
        <p class="ds-dining-course">{{ diningContent.course | translate }}</p>
        }
        @for (diningItem of diningContent.meals; track diningItem.label) {
        <div class="ds-dining-meal-item">
            <p class="ds-dining-meal-label">{{ diningItem.label }}</p>
            @if (diningItem.description) {
            <p class="ds-dining-meal-description">{{ diningItem.description }}</p>
            }
            @if (diningItem.info) {
            <p class="ds-dining-meal-info">{{ diningItem.info }}</p>
            }
        </div>
        }
    </div>
    }
</div>
}
@if (!content().diningContent) {
<div class="body-content body-text"
    [dsScrollContent]="controller()"
    [innerText]="content().bodyText | replaceNonBreakingSpaces | translate">
</div>
}
